import React from 'react';

const ErrorFallback: React.FC = () => {
  return <div>Something went wrong.</div>;
};

export default ErrorFallback;
